import React, {useState} from 'react';
import { Spinner } from 'react-bootstrap';

import axios from '../../admin-axios';
import { ReactComponent as CancelIcon } from '../../assets/Images/cancel_icon.svg';

const CreateCINBoxRow = ({ cin, customer_id, setCinList }) => {
  const [deleteCinLoading, setDeleteCinLoading] = useState(false);

  const deleteCIN = async (cylinder_id) => {
    try {
      setDeleteCinLoading(true);
      await axios.delete(`/cylinder/cin/delete/${cylinder_id}`);
      const response = await axios.get(`/cylinder/cin/view/${customer_id}`);
      setCinList(response.data.data);
      setDeleteCinLoading(false);
    } catch (e) {
      setDeleteCinLoading(false);
    }
  };
  return (
    <div className="d-flex justify-content-between p-2 m-4 create_cin_list_box_row">
      <span className="pt-1">{cin.cin}</span>
      <div className='d-flex'>
        <div className="pt-1 me-3">{cin.gas_quantity}</div>
        <div>
          {deleteCinLoading ? (
            <div className="text-center w-100 h-100">
              <Spinner animation="border" variant="dark" />
            </div>
          ) : (
            <button
              type="button"
              onClick={() => {
                deleteCIN(cin.cylinder_id);
              }}>
              <CancelIcon />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateCINBoxRow;
